import React from 'react';
import SEO from '../components/SEO';
import { motion } from 'framer-motion';
import Contact from '../components/Contact';
import MapSection from '../components/MapSection';

const ContactPage = () => {
  return (
    <>
      <SEO 
        title="Contact Us & Book Appointment | Dr. Suresh Pet Care Hospital"
        description="Get in touch with Dr. Suresh Pet Care Specialist Hospital in Vanasthalipuram. Book your pet's appointment via WhatsApp for priority clinical care."
        canonical="/contact"
      />
      <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="bg-white min-h-screen pt-[140px] md:pt-[140px]"
    >
      {/* Reusing the existing robust Contact component which contains the booking form */}
      <Contact />
      <MapSection />
    </motion.div>
    </>
  );
};

export default ContactPage;
